import LocationForm from 'components/locations/locationForm';
import React from 'react';

const CreateLocation = () => {
    return (
        <div className='content'>
            <LocationForm />
        </div>
    )
}

export default CreateLocation